module Tapas.Bindings {
    export interface IVideoPopupArgs {
        startUrl?: string;
        urlId?: string;
        settings?: string;
        videoUrl?: string;
        modalSelector?: string;
        modalClosewButtonSelector?: string;
    }
    export class VideoPopup {
        public init(element: any, valueAccessor: () => IVideoPopupArgs, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            element = $(element);
            var values = valueAccessor(),
            startUrl = values.startUrl,
            videoID = values.urlId,
            settings = values.settings,
            videoUrl = startUrl + videoID + settings,
            videoModal = values.modalSelector,
            modalClosewButtonSelector = values.modalClosewButtonSelector

            element.on('click', function(){
                $(videoModal).prepend("<iframe width class='modal-embed' src=" + videoUrl + " allowfullscreen=''></iframe>");
            });

            $(modalClosewButtonSelector).on('click', function () {
                $(".modal-embed").remove();
            });

        }
    };
    ko.bindingHandlers['videoPopup'] = new VideoPopup();
}